
import { Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ApiService } from '../../../services/communications/api.service';
import { MediaType } from '../../../constants/constants';
import { MediaPreviewComponent } from '../message/media-preview/media-preview.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import moment from 'moment';


export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY/MM/DD',
    timeInput: 'HH:mm'
  },
  display: {
    dateInput: 'YYYY/MM/DD',
    monthLabel: 'MMM',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
    timeInput: 'HH:mm',
    timeOptionLabel: 'HH:mm'
  },
};

@Component({
  selector: 'summary-modal',
  imports: [FormsModule, MatInputModule, MatFormFieldModule, MatButtonModule, MatDialogModule, TranslateModule, MatIconModule, MatDatepickerModule, MatTimepickerModule, MatProgressSpinnerModule],
  templateUrl: './summary-modal.component.html',
  styleUrls: ['./summary-modal.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ]
})

export class SummaryModalComponent {

  @ViewChild('actionButton') actionButton!: ElementRef<HTMLButtonElement>;

  defaultStartDate!: Date;
  defaultStartTime!: moment.Moment;
  summary: string = '';
  files: any[] = [];
  assetId!: number;
  mediaTypeEnum = MediaType;
  isLoading = false;

  constructor(public dialogRef: MatDialogRef<SummaryModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private apiService: ApiService, private translate: TranslateService, public dialog: MatDialog, private renderer: Renderer2) {
    console.log("current lang", this.translate.currentLang);
    
    this.assetId = data.assetId;
    const currentDate = new Date();
    var startDate = new Date(currentDate.setDate(currentDate.getDate() - 1));
    this.defaultStartDate = startDate;

    const roundHour = Math.floor(startDate.getHours());
    const roundMinutes = Math.floor(startDate.getMinutes() / 30) * 30;

    var time = moment();
    time.hour(roundHour).minutes(roundMinutes).seconds(0);
    this.defaultStartTime = time;
  }

  ngAfterViewInit() {
    const width = this.actionButton.nativeElement.offsetWidth;
    this.renderer.setStyle(this.actionButton.nativeElement.parentElement, 'min-width', `${width}px`);
  }

  combineDateTime(date: Date, time: moment.Moment): Date {
    const result = new Date(date);
    result.setHours(time.hour(), time.minute(), 0, 0);
    return result;
  }

  onSubmit(form: NgForm) {
    if (form.valid) {
      this.isLoading = true;

      var { startDate, startTime, endDate, endTime } = form.value;

      if (endDate == '') endDate = new Date();

      const startDateComplete = startTime != '' ? this.combineDateTime(startDate, startTime) : startDate;
      const endDateComplete = endTime != '' ? this.combineDateTime(endDate, endTime) : endDate;

      console.log(startDateComplete, endDateComplete);

      this.apiService.getChatSummary(this.assetId, startDateComplete, endDateComplete, this.translate.currentLang).subscribe(data => {
        if (data.message == '') this.translate.get("CHAT_SUMMARY.NO_MESSAGES").subscribe((text: string) => { data.message = text; }); 
        this.summary = data.message;
        this.files = data.files;
        this.isLoading = false;
      });
    }
  }

  openMediaModal(url: string, mediaType: MediaType): void {
    const dialogRef = this.dialog.open(MediaPreviewComponent, {
      height: 'auto',
      maxHeight: '90vh',
      data: {
        url: url,
        mediaType: mediaType
      }
    });
  }

  downloadFile(url: string) {
    window.open(url, '_blank');
  }


}
